import React, { useEffect, useState } from "react";
import useSave from "../Hooks/useSave";

export default function ProtectRoutes() {
  const { fetchGraphql } = useSave();
  const [permissions, setPermissions] = useState(["viewCreatePassword"]);

  useEffect(() => {
    if (localStorage.getItem("token")) {
      fetchGraphql({
        query: `query Query {
        userPermissions
      }`,
      }).then((result) => setPermissions(result.data.userPermissions));
    }
  }, []);

  function canView(view) {
    const hasPermission = permissions.includes(view);

    return hasPermission
  }

  return canView
}
